import { useState, useEffect } from 'react';
import { useAuth0 } from 'Auth';

export const useToken = () => {
  const { getToken } = useAuth0();
  const [token, setToken] = useState<string | null>(null);

  useEffect(() => {
    const setTokenValue = async () => {
      const token = await getToken();
      setToken(token);
    };
    setTokenValue();
  }, [getToken]);

  return token;
};
